import * as React from 'react'
import { Route } from 'react-router-dom'

import Auth from './containers/Auth'
import Main from './containers/Main'
import Print from './containers/Print'

const Routes = () => (
  <Auth>
    <Route
      render={props => !props.location.pathname.includes('/print/') && <Main />}
    />
    <Route path="/print/:company/:id" exact component={Print} />
  </Auth>
)

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.tsx